import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, take } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { AppRoutes, NotificationsRoutes } from '@core';
import {
  NotificationPreferenceCategoryQueryResult,
  NotificationPreferencesQueryHandler,
  ToggleNotificationPreferenceCommandHandler
} from '../../application/handlers';

@Component({
  selector: 'lib-notification-preferences',
  templateUrl: './notification-preferences.component.html',
  styleUrls: ['./notification-preferences.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, TitileNavbarComponent, PageLayoutComponent],
  providers: [NotificationPreferencesQueryHandler, ToggleNotificationPreferenceCommandHandler]
})
export class NotificationPreferencesComponent {
  private readonly preferencesQueryHandler: NotificationPreferencesQueryHandler = inject(
    NotificationPreferencesQueryHandler
  );
  private readonly toggleCommandHandler: ToggleNotificationPreferenceCommandHandler = inject(
    ToggleNotificationPreferenceCommandHandler
  );

  readonly alertSettingsUrl: string = `/${AppRoutes.NOTIFICATIONS}/${NotificationsRoutes.ALERTS}`;

  private readonly preferences$: Observable<NotificationPreferenceCategoryQueryResult[]> =
    this.preferencesQueryHandler.getPreferences();

  readonly preferences: Signal<NotificationPreferenceCategoryQueryResult[] | undefined> = toSignal(this.preferences$);

  toggle(category: NotificationPreferenceCategoryQueryResult, event: CustomEvent<{ checked: boolean }>): void {
    if (!category.editable) return;

    const enabled: boolean = event.detail.checked;
    this.toggleCommandHandler.toggle(category.category, enabled).pipe(take(1)).subscribe();
  }
}
